import AppointmentComposeAdapter from '../../adapters/AppointmentComposeAdapter';
import { AddRemoveEnhancedLocationsArgs } from './LocationDetails';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult, createSuccessResult } from '../ApiMethodResponseCreator';
import { getAdapter } from '../../adapters/AdapterManager';
import { isValidLocationIdentifiersArray } from './enhancedLocationsUtils';

export default function removeEnhancedLocationsAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    data: AddRemoveEnhancedLocationsArgs,
    callback: ApiMethodCallback
) {
    const adapter = getAdapter(hostItemIndex) as AppointmentComposeAdapter;
    if (!data || !isValidLocationIdentifiersArray(data.enhancedLocations)) {
        callback(createErrorResult());
        return;
    }
    adapter.removeEnhancedLocations(data.enhancedLocations);
    callback(createSuccessResult());
}
